import React from "react";
import CardWrapper from "../../component/CardWrapper";
import Card from "../../component/Card";
import EmployeeRanks from '../../component/Displays/Tables/EmployeeRanks';
import './index.scss';

const EmployeeLeaderBoard: React.FC<any> = ({}) => {
    return (
        <div className="leaderboard-container">
            <div className="guages">
                <CardWrapper>
                    <Card content={<>select chart</>} />
                </CardWrapper>
            </div>
            <div className="cards">
                <CardWrapper>
                    <Card content={<EmployeeRanks />} />
                </CardWrapper>
            </div>
        </div>
    );
}

export default EmployeeLeaderBoard;